import { Injectable } from "@angular/core";

import { Observable, Subject } from "rxjs";

import { ModalDialogModel } from "./modal-dialog.model";

@Injectable()
export class ModalDialogService {
    private _content = new Subject<ModalDialogModel>();

    public get content(): Observable<ModalDialogModel> {
        return this._content;
    }

    public show(model: ModalDialogModel): void {
        this._content.next(model);
    }

    public hide(): void {
        this._content.next(null);
    }
}
